import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ClientRoute from '../../auth/containers/ClientRouteContainer';
import LoginPage from '../../auth/containers/LoginPageContainer';
import RegistrationPage from '../../auth/containers/RegistrationPageContainer';
import PortalPage from '../../campaigns/containers/PortalPageContainer';
import SurveyBuilderPage from '../../surveys/containers/SurveyBuilderPageContainer';
import CampaignResultsPage from '../../campaigns/containers/CampaignResultsPageContainer';
import ViewCampaignResultsPage from '../../campaigns/components/CampaignResults/ViewCampaignResultsPage';
import PushNotificationsCenter from '../../portals/PushNotificationsCenter/PushNotificationsCenter';
import CouponManagementPage from '../../portals/CouponManagement/containers/CouponManagementPage';
import ProfileTagsManagement from '../../portals/ProfileTagsManagement/containers/ProfileTagsManagement';
import AccountManagement from '../../portals/AccountManagement/containers/AccountManagement';
import ClientsInvitation from '../../auth/containers/ClientsInvitationContainer';
import CommunityDashboard from '../../portals/CommunityDashboard/containers/CommunityDashboard';

const Router = ({ webSocketUrl }) => (
  <div style={style.fullHeight}>
    <BrowserRouter basename="/clients">
      <div style={style.fullHeight}>
        <Switch>
          <Route exact path="/auth/login" component={LoginPage} />
          <Route exact path="/auth/register" component={RegistrationPage} />
          <Route
            exact
            path="/invitation/:token?"
            component={ClientsInvitation}
          />
          <Route
            exact
            path="/campaigns/:id/view/:viewToken"
            component={ViewCampaignResultsPage}
          />

          <ClientRoute exact path="/" component={PortalPage} />
          <ClientRoute
            path="/survey/:id/edit/:tab?/:nodeId?/"
            webSocketUrl={webSocketUrl}
            component={SurveyBuilderPage}
          />
          <ClientRoute
            exact
            path="/campaign/:id/results"
            component={CampaignResultsPage}
          />
          <ClientRoute
            exact
            path="/notifications"
            component={PushNotificationsCenter}
          />
          <ClientRoute exact path="/coupons" component={CouponManagementPage} />
          <ClientRoute
            exact
            path="/account-management/:customerId?/:teamId?"
            component={AccountManagement}
          />
          <ClientRoute
            exact
            path="/profile-tags-management"
            component={ProfileTagsManagement}
          />
          <ClientRoute
            exact
            path="/community-dashboard"
            component={CommunityDashboard}
          />
        </Switch>
      </div>
    </BrowserRouter>
  </div>
);

const style = {
  fullHeight: {
    height: '100vh'
  }
};

export default Router;
